/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { useEffect, useState } from 'react';
import { bool, func } from 'prop-types';
import { makeStyles, useMediaQuery } from '@material-ui/core';
import { emailRegexp } from '../constants/input';

const useStyles = makeStyles((theme) => ({
    emailTranscriptModal: {
        position: 'absolute',
        top: '100px',
        width: '100%',
        zIndex: 9999,
        padding: '0 30px',
    },
    mediaModalDialog: {
        maxWidth: '100%',
        margin: '0 auto',
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: '#fff !important',
        border: '1px solid rgba(0,0,0,.2)',
        borderRadius: '.3rem',
        outline: '0',
    },
    emailTranscriptModalDialog: {
        maxWidth: '100%',
        margin: '0 auto',
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: '#fff !important',
        border: '1px solid rgba(0,0,0,.2)',
        borderRadius: '.3rem',
        outline: '0',
    },
    emailTranscriptContent: {
        backgroundColor: '#fff',
        boxShadow: '0 2px 1px -1px rgba(0,0,0,0.2), 0 1px 1px 0 rgba(0,0,0,0.14), 0 1px 3px 0 rgba(0,0,0,0.12)',
    },
    emailTranscriptInput: {
        width: '100%',
        height: '45px',
        borderRadius: '4px white',
    },
    emailTranscriptHeader: {
        padding: '0 16px',
    },
    successEmail: {
        padding: '10px',
    },
    successMessage: {
        color: `${theme.palette.cms?.primary || theme.palette.colorPrimary}`,
        padding: '2rem',
        zIndex: '999',
        position: 'absolute',
        backgroundColor: '#ffffff',
        top: '100px',
        width: '100%',
        fontSize: '16px',
        border: '1px solid rgba(0,0,0,.2)',
        borderRadius: '.3rem',
        boxShadow: '0 2px 1px -1px rgba(0,0,0,0.20), 0 1px 1px 0 rgba(0,0,0,0.14), 0 1px 3px 0 rgba(0,0,0,0.12)',
    },
    emailTranscriptMessage: {
        display: 'inline',
        '&:before': {
            content: '\'a',
            whiteSpace: 'pre',
        },
    },
    emailTranscriptBody: {
        borderTop: '1px solid rgba(0, 0, 0, 0.12)',
        padding: '15px 19px',
    },
    emailFooterModel: {
        borderTop: 0,
        justifyContent: 'space-between',
        padding: '1rem',
        display: 'flex',
        alignItems: 'center',
    },
    confirmBtn: {
        marginLeft: '10px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '.5rem .75rem',
        fontSize: '1rem',
        color: '#fff',
        '&:hover': {
            color: '#fff',
        },
        '&:disabled': {
            backgroundColor: `${theme.palette.cms?.colorNeutral70 || theme.palette.colorNeutral70}`,
            border: `2px solid ${theme.palette.cms?.colorNeutral70 || theme.palette.colorNeutral70}`,
        },
        backgroundColor: `${theme.palette.cms?.primary || theme.palette.colorPrimary}`,
        border: `2px solid ${theme.palette.cms?.primary || theme.palette.colorPrimary}`,
        borderRadius: '.25rem',
        cursor: 'pointer',
    },
    confirmBtnOutline: {
        backgroundColor: '#fff',
        color: `${theme.palette.cms?.primary || theme.palette.colorPrimary}`,
        border: `2px solid  ${theme.palette.cms?.primary || theme.palette.colorPrimary}`,
        padding: '.5rem .75rem',
        fontSize: '1rem',
        borderRadius: '.25rem',
        marginLeft: '10px',
        cursor: 'pointer',
    },
}));

const EmailTranscriptInput = ({
    onSubmitEmail, showEmailTranscriptInput, cancelEmailTranscript, emailSuccesMessage,
}) => {
    const matches = useMediaQuery('(min-width: 576px)');
    const classes = useStyles();
    const [responsiveEmailInputModal, setResponsiveEmailInputModal] = useState(undefined);
    const [email, setEmail] = useState('');
    const [isInvalidEmail, setIsInvalidEmail] = useState(true);

    /**
     * Adjust modal styles to match the current resolution.
     */
    useEffect(() => {
        if (matches) {
            setResponsiveEmailInputModal('mediaModalDialog');
        } else {
            setResponsiveEmailInputModal('emailTranscriptModalDialog');
        }
    }, [matches]);

    const onChangeEmail = (value) => {
        setEmail(value);
        setIsInvalidEmail(!emailRegexp.test(value));
    };

    if (showEmailTranscriptInput) {
        return (
            <div id="email-transcript-input" className={classes.emailTranscriptModal}>
                <div className={responsiveEmailInputModal === 'mediaModalDialog' ? classes.mediaModalDialog : classes.emailTranscriptModalDialog}>
                    <form
                        onSubmit={(e) => {
                            e.preventDefault();
                            onSubmitEmail(email);
                        }}
                        data-testid="email-transcript-input-form"
                    >
                        <div className={classes.emailTranscriptContent} />
                        <div className={classes.emailTranscriptHeader}>
                            <h4 data-testid="email-transcript-heading">Email Transcript</h4>
                        </div>
                        <div className={classes.emailTranscriptBody}>
                            <label htmlFor="email">
                                Email:
                                <input
                                    type="email"
                                    value={email}
                                    onChange={(e) => {
                                        onChangeEmail(e.target.value);
                                    }}
                                    className={classes.emailTranscriptInput}
                                    placeholder="Enter email"
                                    data-testid="email-transcript-input"
                                />
                            </label>

                        </div>
                        <div className={classes.emailFooterModel}>
                            <button type="submit" disabled={!email || isInvalidEmail} className={classes.confirmBtn} data-testid="email-transcript-send">Send</button>
                            <button type="button" onClick={cancelEmailTranscript} className={classes.confirmBtnOutline} data-testid="email-transcript-cancel">Cancel</button>
                        </div>

                    </form>
                </div>
            </div>
        );
    }

    if (emailSuccesMessage) {
        return (
            <div id="successEmail" className={classes.successEmail}>
                <div className={classes.successMessage}>
                    After the end of chat.
                    <span className={classes.emailTranscriptMessage}> Email will be sent to {email}.</span>
                </div>
            </div>

        );
    }

    return null;
};

EmailTranscriptInput.propTypes = {
    onSubmitEmail: func.isRequired,
    showEmailTranscriptInput: bool.isRequired,
    cancelEmailTranscript: func.isRequired,
    emailSuccesMessage: bool.isRequired,
};

export default EmailTranscriptInput;
